<div [class.has-environment-banner]="!isProduction">
  <header>
    @if (!isProduction) {
      <lib-environment-banner></lib-environment-banner>
    }

    <nav class="navbar main-menu">
      <a class="navbar-brand"
        ><img src="assets/Vector.svg" alt="Vinnovas logga, ett grönt V" />
        <span class="h4">Utlysningsbyggaren</span></a
      >
    </nav>
  </header>
  <lib-toast-container></lib-toast-container>
  <main class="ip-body" id="main-content">
    <div class="container-xxl position-relative flex-fill">
      @if (!hasError) {
        @if (customContent()) {
          <div class="main">
            <ng-content></ng-content>
          </div>
        } @else {
          <router-outlet></router-outlet>
        }
      }
    </div>
  </main>
</div>
